import "./internal.js";
import BetterMenu from "./lib/better-menu/better-menu";
import BetterModal from "./lib/better-menu/better-modal";

console.log("App.js is loading");

document.addEventListener("DOMContentLoaded", function () {
	console.log("DOM Content Loaded");
	document.querySelector("body").setAttribute("data-s-loaded", "");
	new BetterMenu();
	new BetterModal();
});
